var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"money",style:({ width: 130 + _vm.cards.length * 60 +'px' })},[_c('div',{staticClass:"cards"},_vm._l((_vm.cards),function(card,index){return _c('div',{key:index,staticClass:"card",style:({ 
                left: index * 60 + 'px', 
                'z-index': 1000 - index,
                height: 80 - index * 5 + 'px',
                'background-image': _vm.background
            })},[(index == 0)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"value"},[_vm._v(" ¥ "),_c('span',[_vm._v(_vm._s(card))])])])}),0),_c('div',{staticClass:"shadow"})])}
var staticRenderFns = []

export { render, staticRenderFns }